import RoleBasedLayout from "./RoleBasedLayout";
import LetterPage from "../ui/LetterPage";

export default function Letters() {
    return (
        <RoleBasedLayout>
            <LetterPage />
        </RoleBasedLayout>
    );
}